import { useState, type ReactNode } from 'react';
import { isAuthenticated } from '../lib/auth';
import Login from '../pages/Login';

export function AuthGuard({ children }: { children: ReactNode }) {
  const [authenticated, setAuthenticated] = useState(isAuthenticated);
  if (authenticated && isAuthenticated()) return <>{children}</>;
  return <Login onAuthenticated={() => setAuthenticated(true)} />;
}
